export default __webpack_public_path__ + "static/3-ddbb4f70dfe6b3316516010570882a8b.mp4";